module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (87).4dcbd584.jpg";